var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.23,60.25c0,10.49-8.51,19-19,19s-19-8.51-19-19s8.51-19,19-19C70.72,41.26,79.22,49.76,79.23,60.25z  M119.6,34.13v52.24c-0.02,18.35-14.89,33.22-33.24,33.24H34.12c-18.35-0.02-33.22-14.89-33.24-33.24V34.13 C0.89,15.78,15.76,0.9,34.12,0.88h52.24C104.71,0.9,119.58,15.78,119.6,34.13z M88.73,60.25c0-15.74-12.76-28.5-28.5-28.5 s-28.5,12.76-28.5,28.5s12.76,28.5,28.5,28.5C75.97,88.73,88.71,75.98,88.73,60.25z M98.23,29.38c0-3.93-3.19-7.12-7.12-7.12 c-3.93,0-7.12,3.19-7.12,7.12s3.19,7.12,7.12,7.12C95.04,36.5,98.23,33.31,98.23,29.38z",
    fill: "#E40053"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/Instagram_icon.e1cc6d8a0e098f6f851f4c924a6fec7f.svg";
export { ForwardRef as ReactComponent };